// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "serviceWrapper-bdJnN";
var _3 = "button-VxBVr";
export { _1 as "__esModule", _2 as "serviceWrapper", _3 as "button" }
export default { "__esModule": _1, "serviceWrapper": _2, "button": _3 }
